import React, { useState, useEffect, useRef } from 'react';
import { fmtTokens } from '../utils/helpers';
import { calculateNetWorth } from '../constants/richness';
import './shell.css';

const sv = { fill: 'none', stroke: 'currentColor', strokeWidth: '1.8', strokeLinecap: 'round', strokeLinejoin: 'round' };
const IcoLeaderboard = () => <svg width="17" height="17" viewBox="0 0 24 24" {...sv}><path d="M18 20V10M12 20V4M6 20v-6" /></svg>;
const IcoBox         = () => <svg width="17" height="17" viewBox="0 0 24 24" {...sv}><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" /><path d="m3.3 7 8.7 5 8.7-5M12 22V12" /></svg>;
const IcoMarket      = () => <svg width="17" height="17" viewBox="0 0 24 24" {...sv}><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" /><line x1="3" x2="21" y1="6" y2="6" /><path d="M16 10a4 4 0 0 1-8 0" /></svg>;
const IcoCasino      = () => <svg width="17" height="17" viewBox="0 0 24 24" {...sv}><rect width="20" height="14" x="2" y="5" rx="2" /><line x1="2" x2="22" y1="10" y2="10" /></svg>;
const IcoStats       = () => <svg width="17" height="17" viewBox="0 0 24 24" {...sv}><line x1="18" x2="18" y1="20" y2="10" /><line x1="12" x2="12" y1="20" y2="4" /><line x1="6" x2="6" y1="20" y2="14" /></svg>;
const IcoPass        = () => <svg width="17" height="17" viewBox="0 0 24 24" {...sv}><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2z" /></svg>;
const IcoStocks      = () => <svg width="17" height="17" viewBox="0 0 24 24" {...sv}><polyline points="22 7 13.5 15.5 8.5 10.5 2 17" /><polyline points="16 7 22 7 22 13" /></svg>;
const IcoSettings    = () => <svg width="17" height="17" viewBox="0 0 24 24" {...sv}><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" /><circle cx="12" cy="12" r="3" /></svg>;
const IcoAdmin       = () => <svg width="17" height="17" viewBox="0 0 24 24" {...sv}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>;
const IcoBell        = () => <svg width="15" height="15" viewBox="0 0 24 24" {...sv}><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" /></svg>;

const TAB_META = {
  leaderboard: { label: 'Leaderboard', Icon: IcoLeaderboard },
  lootbox:     { label: 'Lootbox',     Icon: IcoBox },
  marketplace: { label: 'Marketplace', Icon: IcoMarket },
  casino:      { label: 'Casino',      Icon: IcoCasino },
  stocks:      { label: 'Stocks',      Icon: IcoStocks },
  stats:       { label: 'Stats',       Icon: IcoStats },
  pass:        { label: 'Pass',        Icon: IcoPass },
  settings:    { label: 'Settings',    Icon: IcoSettings },
  admin:       { label: 'Players',     Icon: IcoAdmin },
};
const TAB_ORDER = ['leaderboard', 'lootbox', 'marketplace', 'casino', 'stocks', 'stats', 'pass', 'settings', 'admin'];

function fmtTimeAgo(ts) {
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 60) return 'just now';
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

export default function Sidebar({
  page, setPage, isAdmin, user, userData, tokenAdjustment,
  onLogout, onChangeIgn,
  unreadCount, notifications, showNotifications, setShowNotifications,
  onMarkRead, onClearAll, seasonConfig, hasClaimablePassRewards, liveStockValue,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const footRef = useRef(null);

  // Close menus when clicking outside the sidebar footer
  useEffect(() => {
    if (!menuOpen && !showNotifications) return;
    const handler = e => {
      if (footRef.current && !footRef.current.contains(e.target)) {
        setMenuOpen(false);
        if (showNotifications) setShowNotifications(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen, showNotifications, setShowNotifications]);

  const tabs = TAB_ORDER.filter(id => id !== 'admin' || isAdmin).map(id => ({ id, ...TAB_META[id] }));

  const seasonLabel = seasonConfig?.currentSeason
    ? `SEASON ${seasonConfig.currentSeason}`
    : 'SEASON 2';

  const crewTokens = Math.max(0, (userData?.crewmateTokens || 0) - (tokenAdjustment?.crewmate || 0));
  const impTokens  = Math.max(0, (userData?.imposterTokens  || 0) - (tokenAdjustment?.imposter  || 0));
  const netWorth = userData
    ? calculateNetWorth(liveStockValue != null ? { ...userData, stockPortfolioValue: liveStockValue } : userData, true).total
    : 0;

  const ignDisplay = userData?.ign || user?.email?.split('@')[0] || 'Guest';
  const level = userData?.level || 1;
  const xp = userData?.xp || 0;

  return (
    <aside className="v2-sidebar">
      <div className="v2-sidebar__head">
        <img src="/logo192.png" alt="AmongLR" className="v2-sidebar__logo-img" />
        <div>
          <div className="v2-sidebar__logo-txt">AMONG<span>LR</span></div>
          <div className="v2-sidebar__season">{seasonLabel}</div>
        </div>
      </div>

      <nav className="v2-sidebar__nav">
        {tabs.map(t => {
          const active = page === t.id;
          return (
            <button
              key={t.id}
              type="button"
              className={`v2-sidebar__tab${active ? ' v2-sidebar__tab--active' : ''}`}
              onClick={() => setPage(t.id)}
            >
              <span className="v2-sidebar__tab-icon"><t.Icon /></span>
              {t.label}
              {t.id === 'pass' && hasClaimablePassRewards && <span className="v2-sidebar__tab-dot" />}
            </button>
          );
        })}
      </nav>

      <div className="v2-sidebar__foot" ref={footRef}>
        {user && userData && (
          <>
            <div className="v2-currency-grid">
              <div className="v2-currency-pill v2-currency-pill--crew">
                <div className="v2-currency-pill__label">🔵 CREW</div>
                <div className="v2-currency-pill__value">{fmtTokens(crewTokens)}</div>
              </div>
              <div className="v2-currency-pill v2-currency-pill--imp">
                <div className="v2-currency-pill__label">🔴 IMP</div>
                <div className="v2-currency-pill__value">{fmtTokens(impTokens)}</div>
              </div>
            </div>
            <div className="v2-currency-pill v2-currency-pill--nw">
              <div className="v2-currency-pill__label">NET WORTH</div>
              <div className="v2-currency-pill__value">${fmtTokens(netWorth)}</div>
            </div>
          </>
        )}

        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {user ? (
            <>
              <button
                type="button"
                className="v2-user-row"
                onClick={() => { setMenuOpen(v => !v); if (showNotifications) setShowNotifications(false); }}
              >
                <span className="v2-user-row__avatar">👤</span>
                <div className="v2-user-row__body">
                  <div className="v2-user-row__name">{ignDisplay}</div>
                  <div className="v2-user-row__sub">Lvl {level} · {xp} XP</div>
                </div>
              </button>
              <button
                type="button"
                className="v2-bell-btn"
                onClick={() => { setShowNotifications(!showNotifications); setMenuOpen(false); }}
                aria-label="Notifications"
              >
                <IcoBell />
                {unreadCount > 0 && <span className="v2-bell-badge">{unreadCount}</span>}
              </button>
            </>
          ) : (
            <button type="button" className="v2-sidebar__login" onClick={() => setPage('admin')}>
              🔓 LOGIN
            </button>
          )}
        </div>

        {menuOpen && user && (
          <div className="v2-user-menu">
            <button type="button" className="v2-user-menu__item" onClick={() => { onChangeIgn(); setMenuOpen(false); }}>
              ✏️ Change IGN
            </button>
            <button type="button" className="v2-user-menu__item v2-user-menu__item--danger" onClick={() => { onLogout(); setMenuOpen(false); }}>
              🚪 Logout
            </button>
          </div>
        )}

        {showNotifications && user && (
          <div className="v2-notif-drop">
            <div className="v2-notif-drop__head">
              <h3>Notifications</h3>
              {notifications.length > 0 && (
                <button type="button" className="v2-notif-drop__clear" onClick={onClearAll}>Clear All</button>
              )}
            </div>
            <div className="v2-notif-drop__list">
              {notifications.length === 0 ? (
                <div className="v2-notif-drop__empty">No notifications</div>
              ) : (
                notifications.map(n => (
                  <div
                    key={n.id}
                    className={`v2-notif-drop__item${n.read ? '' : ' v2-notif-drop__item--unread'}`}
                    onClick={() => onMarkRead(n.id)}
                  >
                    <span className="v2-notif-drop__icon">
                      {n.type === 'auction_won'     && '🏆'}
                      {n.type === 'auction_sold'    && '💰'}
                      {n.type === 'auction_expired' && '⏰'}
                      {n.type === 'item_sold'       && '💰'}
                      {n.type === 'daily_reward'    && '🎁'}
                      {n.type === 'achievement'     && '⭐'}
                    </span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="v2-notif-drop__msg">{n.message}</div>
                      <div className="v2-notif-drop__time">{fmtTimeAgo(n.timestamp)}</div>
                    </div>
                    {!n.read && <span className="v2-notif-drop__dot" />}
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </aside>
  );
}
